import { fetchCompanyExternalLinks } from '@/api/v4/organization-external-links.api';
import { fetchSpotlightCompanyExternalLinks } from '@/api/v4/spotlight.api';
import { useQuery } from '@tanstack/react-query';
import { getTimeInMs } from '@/helpers/get-time-in-ms';
import { QueryKey } from '@/config/query-client';
import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../company-fetch-context';

const companyExternalLinksFetchers: Record<
  CompanyFetchMode,
  (companyId: string) => ReturnType<typeof fetchCompanyExternalLinks>
> = {
  general: fetchCompanyExternalLinks,
  spotlight: fetchSpotlightCompanyExternalLinks,
};

export const useCompanyExternalLinks = (companyId: string | null) => {
  const fetchMode = useCompanyFetchMode();

  const getCompanyExternalLinks = async () => {
    if (!companyId) {
      return [];
    }

    return companyExternalLinksFetchers[fetchMode](companyId);
  };

  return useQuery({
    queryKey: [QueryKey.CompanyExternalLinks, fetchMode, companyId],
    queryFn: getCompanyExternalLinks,
    staleTime: getTimeInMs(5, 'minute'),
    gcTime: getTimeInMs(5, 'minute'),
  });
};
